"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SelectableCourier = void 0;
var _mui = require("@ori-ui/mui");
var _checkoutUi = require("@ori/checkout-ui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _hooks = require("../../hooks");
var _models = require("../../models");
var _Availability = require("../SelectPickupPointDialog/components/Availability");
var _styles = require("../SelectPickupPointDialog/components/PickupPointCard/styles");
var _Price = require("../SelectPickupPointDialog/components/Price");
var _shared = require("../shared");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/** Used for flat selection UI to display courier item instead of earlier-used `CourierBox`. */ const SelectableCourier = (param)=>{
    let { activateCourier, courier, hintMessages = [], isBoundCourier, isActive, isDisabled, onShippingOfferBannerClick, outOfStockQuantity } = param;
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { formatMessage } = (0, _hooks.useTranslations)();
    const { deliveryChannelId, deliveryFee, estimatedDelivery, image, isShippingJoker, name, originalDeliveryFee } = courier;
    const ownerState = {
        isDisabled,
        isFlatSelection: true
    };
    const rootTestiId = isBoundCourier ? _models.TestId.BoundCourierBox : _models.TestId.CourierBox;
    const courierInfoTestId = isDisabled ? _models.TestId.CourierInfoDisabled : _models.TestId.CourierInfo;
    const onClick = (0, _react.useCallback)(()=>{
        void activateCourier({
            deliveryChannelId,
            courierName: name
        });
    }, [
        activateCourier,
        deliveryChannelId,
        name
    ]);
    const isLogoWrapperVisible = Boolean(image) || isShippingJoker;
    const selectableCardProps = {
        disabled: isDisabled,
        // || isRefreshPending, // || isAddressFormOpen,
        indicator: 'radio',
        onClick,
        selected: isActive,
        ...getTestIdProps(rootTestiId),
        // hints & shipping offer banner, optional button section top alignment
        ...(0, _shared.getAdditionalSelectableCardProps)({
            isActive,
            isAlignedToTop: !isLogoWrapperVisible,
            hintMessages,
            isShippingJoker,
            onShippingOfferBannerClick,
            shippingOfferBannerText: formatMessage('buyProductAndGetFreeDelivery')
        })
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_checkoutUi.SelectableCard, {
        ...selectableCardProps,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_shared.SelectableCardContent, {
            ...getTestIdProps(courierInfoTestId),
            children: [
                isLogoWrapperVisible ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_shared.TopRowWrapper, {
                    children: [
                        image ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles2.Image, {
                            src: image.src,
                            alt: image.alt,
                            ...getTestIdProps(_models.TestId.CourierImage),
                            ownerState: ownerState
                        }) : null,
                        isShippingJoker ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Chip, {
                            color: "offer",
                            label: formatMessage('freeShippingOffer'),
                            variant: "tag"
                        }) : null
                    ]
                }) : null,
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_shared.ContentRowWrapper, {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_shared.Content, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        children: name
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.ContentRowWrapper, {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.DateAndAvailability, {
                                        children: [
                                            estimatedDelivery ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                                                children: estimatedDelivery
                                            }) : null,
                                            isActive && !isDisabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Availability.Availability, {
                                                quantity: outOfStockQuantity
                                            }) : null
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(_shared.ContentRight, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Price.Price, {
                                originalShippingFee: originalDeliveryFee,
                                shippingFee: deliveryFee
                            })
                        })
                    ]
                })
            ]
        })
    });
};
exports.SelectableCourier = SelectableCourier;
